import { render, staticRenderFns } from "./SinglePayPlanChangeRequest.vue?vue&type=template&id=844a926a"
import script from "./SinglePayPlanChangeRequest.vue?vue&type=script&lang=ts"
export * from "./SinglePayPlanChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports